import React from "react";
import ProductAnalysisShadow from "./ProductAnalysisShadow";

// 商品分析（RN-161）: プロトの「商品別」を既定表示。
// 「流入経路別」「ランク別」はこの画面に従属タブとして内包する（メニューには出さない）。
export default function ProductAnalysisPage() {
    return <ProductAnalysisShadow views={["prod", "flow", "rank"]} defaultView="prod" />;
}
